<div class="modal-header">
    <h5 class="pt-4" style="padding-left:2rem">Relleno de línea</h5>
    <button type="button" class="btn-close me-4" mat-dialog-close></button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
    <div class="modal-body mb-4">
            <div class="row g-3">
                <div class="col-md-7">

                    <mat-card class="info-card2">
                        <mat-card-content>
                            <div class="d-flex justify-content-between align-items-center">
                                <h6><b>Información general</b></h6>
                            </div>
                            <mat-divider></mat-divider>
                            <div class="mt-3 d-flex justify-content-between">
                                <span>Material</span><span><b>{{dataMat.nombre}}</b></span>
                            </div>
                            <div class="mt-2 d-flex justify-content-between">
                                <span>SKU</span><span><b>{{dataMat.sku}}</b></span>
                            </div>
                            <div class="mt-2 d-flex justify-content-between">
                                <span>Cantidad en línea</span><span><b>{{dataMat.en_linea ?? 0}}</b></span>
                            </div>
                            <div class="mt-2 d-flex justify-content-between">
                                <span>Cantidad en inventario</span><span><b>{{dataMat.actual - dataMat.en_linea}}</b></span>
                            </div>
                            <div class="mt-2 d-flex justify-content-between">
                                <span>Límite mínimo</span><span><b>{{dataMat.limite_minimo}}</b></span>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <div class="mt-3">
                        <h6><b>Configuración</b></h6>

                        <mat-radio-group [(ngModel)]="tipoSeleccionado" (change)="onTipoChange()">
                            <div>
                                <mat-radio-button value="peso" *ngIf="dataMat.peso != null && dataMat.peso != 0">
                                    Peso unitario <small>({{dataMat.peso}} kg)</small>
                                </mat-radio-button>
                            </div>
                            <div>
                                <mat-radio-button value="batch">
                                    Tamaño de batch <small>({{ dataMat.batch != null && dataMat.batch != 0 ? this.dataMat.batch : 1  }} {{ batch == 1 ? 'unidad' : 'unidades'}})</small>
                                </mat-radio-button>
                            </div>
                        </mat-radio-group>
                        <div class="mt-4">
                            <label class="form-label fw-bold">Unidades por batch</label>
                            <input type="number" id="tamano" class="form-control w-50" [(ngModel)]="batch" (input)="soloEnteros($event)">
                        </div>

                        <!-- <div class="mt-4">
                            <mat-slide-toggle [(ngModel)]="pesoUnitario">Peso unitario</mat-slide-toggle>
                        </div>
                        <div class="mt-4">
                            <mat-slide-toggle [(ngModel)]="tamanobatch">Tamaño de batch</mat-slide-toggle>
                        </div>
                          -->
                    </div>
                </div>
                <div class="col-md-5 d-flex align-items-center justify-content-center border image-container">
                    <img
                        *ngIf="images != undefined"
						[src]="images[0]"
						class="img-fluid rounded shadow-sm material-img"
						style="object-fit: contain;"
						alt="material"
					/>
                    <label *ngIf="images == undefined" class="form-label fw-bold">Sin imagen</label>
                </div>
            </div>
    </div>
    <div class="modal-footer mt-4">
        <button mat-flat-button class="bg-success text-white ms-5" (click)="saveConf()" type="button">Guardar <mat-icon>save</mat-icon></button>
    </div>
</mat-dialog-content>
